module.exports = __webpack_public_path__ + "static/media/panel_bottom_edge.6849021e.png";